import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
  findIndex,
  propEq,
} from 'ramda';
import Input from '../../common/Input';
import СolorPicker from '../../common/СolorPicker';
import CheckBox from '../../common/CheckBox';
import Breadcrumbs from '../../common/Breadcrumbs';
import fields from './fields';
import { validateFields } from '../../utils/validate';
import { processFields } from '../../utils/prePost';
import { linkDataToFields } from '../../utils/fields';
import { setJobCardById, fetchJobCardById } from '../../api/jobCards';
import '../../css/forms/default-forms.css';
import hasAccess from "../../helpers/permissionChecker";

export class JobCardsEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
      fieldsSync: false,
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
  }

  componentWillMount() {
    this.fetchDataRouteById();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.fieldsSync === false) {
      const currentJobCard = path(['jobCards', 'currentJobCard', '0'], this.props);

      if (currentJobCard) {
        const fields = linkDataToFields(currentJobCard, this.state.fields);
        this.setState({
          fields: fields,
          fieldsSync: true,
        });
      }
    }
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      this.props.saveForm(
        path(['match', 'params', 'id'], this.props),
        processFields(this.state.fields)
      );
    }
    return false;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToJobCard();
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.getDataById(id);
  }

  render() {
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'jobCard',
      'permTypeKey': 'edit',
    });
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/job-cards', icon: 'card_travel', name: 'Job Cards' },
          { icon: 'credit_card', name: 'Edit' }
        ]} />
        <div>
          <div className="card rounded">
            <div className="card-header rounded-top">
              Add Job Card
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                {hasAccessForEdit &&
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
                }
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <CheckBox
                    field={this.state.fields['default']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                  <Input
                    field={this.state.fields['label']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToJobCard: () => {
      dispatch(push('/pages/job-cards'));
    },
    getDataById: (id) => {
      fetchJobCardById({ id: id })(dispatch);
    },
    saveForm: (id, data) => {
      setJobCardById(id, data)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JobCardsEdit);



// WEBPACK FOOTER //
// ./src/containers/JobCardsEdit/index.js